module.exports = ":host {\n  border-top: 1px solid rgba(58, 108, 201, 0.2);\n  width: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  padding: 1.1875em 1.875em; }\n\nspan {\n  font-size: 0.875em; }\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/kiosk/kiosk-footer/kiosk-footer.component.scss
// module id = 1258
// module chunks = 0